import { Box, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { secondaryBlue } from '../../../utils/color';
import TextAndImage from '../../../components/public-screen-components/TextAndImage';
import HowMuchDoesItCost from './components/HowMuchDoesItCost';
import HowToManageHero from './components/HowToManageHero';
import TheFutureOfSmartManaging from './components/TheFutureOfSmartManaging';
import { textsAndImagesBuyer, theFutureOfSmartManagingTextAndIcons } from './utils';
import MetaTags from '../../../components/seo/MetaTags';
import BecomeAPartOfSpona from '../../../components/public-screen-components/BecomeAPartOfSpona';
import { LAYOUT_DEFAULTS } from '../../../utils/constants';

const metaTags = {
  title: `Spona - The Ultimate Project Management Tool is here`,
  description: `End-to-End Project Management is our all-in-one project management tool. Sign contracts, Track project milestones get reports and pay, all in one place.`,
};

const HowToManageBuyer = () => {
  const navigate = useNavigate();

  return (
    <>
      <MetaTags {...metaTags} />
      <Stack overflow="hidden" width="100%">
        <HowToManageHero
          bgcolor={secondaryBlue[501]}
          title="Why Teams Choose Spona’s Project Management tool"
          subtitle="One platform for all your projects, contracts, and external collaborators. Where everything is organized, searchable, and always up to date."
        />

        <Stack spacing={10} sx={{ mt: 12, mb: 18.75 }}>
          {textsAndImagesBuyer.map(({ title, content, image, contentOrder, contentButton, id }) => (
            <TextAndImage
              key={id}
              title={title}
              content={content}
              image={image}
              contentOrder={contentOrder}
              contentButton={contentButton}
            />
          ))}
        </Stack>

        <Stack spacing={6} sx={{ mb: 12 }}>
          <Typography variant="publicHeading3" sx={{ ...LAYOUT_DEFAULTS, textAlign: 'center' }}>
            How much does it cost?
          </Typography>
          <HowMuchDoesItCost
            firstCard={{
              title: 'For Spona users',
              sx: { alignItems: 'start' },
              bgcolor: 'white',
              color: 'black',
              content: (
                <Typography>
                  The Project Management Tool is a free service provided to users who pitch for a
                  project and are hired through Spona, available for the entire duration of the
                  project.{' '}
                </Typography>
              ),
            }}
            secondCard={{
              title: 'For E2E users',
              sx: { alignItems: 'start' },
              bgcolor: secondaryBlue[50],
              color: 'black',
              content: (
                <Typography>
                  The Project Management Tool is a paid service for users that already have a
                  contract with a buyer and are interested only in investing in a management tool.
                </Typography>
              ),
            }}
          />
        </Stack>

        <TheFutureOfSmartManaging
          textAndIcons={theFutureOfSmartManagingTextAndIcons(secondaryBlue[501])}
          bgcolor={secondaryBlue[101]}
        />
      </Stack>
    </>
  );
};

export default HowToManageBuyer;
